// web/src/hooks/useLocaleInit.ts
// Called once inside the auth boundary to seed the locale store from the user's
// profile jurisdiction. Subsequent renders read from the store — no re-fetch.
import { useEffect } from "react";
import { api } from "../lib/apiClient";
import { useLocaleStore } from "../stores/localeStore";
export function useLocaleInit() {
    const setFromJurisdiction = useLocaleStore((s) => s.setFromJurisdiction);
    useEffect(() => {
        api
            .me()
            .then((profile) => {
            const jurisdiction = profile.personal_family?.jurisdiction;
            setFromJurisdiction(jurisdiction);
        })
            .catch(() => {
            // Leave en-US / USD defaults if profile is unavailable.
        });
    }, [setFromJurisdiction]);
}
